module.exports = __webpack_public_path__ + "static/media/lamp3.88c1e6ef.png";